import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

type PortalType = {
  children: React.ReactNode;
}

const Portal: React.FC<PortalType> = ({ children }) => {
  const [portalRoot, setPortalRoot] = useState(null);

  useEffect(() => {
    const el = document.getElementById('portal');
    setPortalRoot(el);
  }, []);

  return (portalRoot && ReactDOM.createPortal(children, portalRoot));
};

export default Portal;
